module.exports = __webpack_public_path__ + "img/标题英文_新闻资讯.1be1efa0.svg";